export default __webpack_public_path__ + "23ab7d4ad31b1e0c19d1f2ced58e61b8.png";